export default __webpack_public_path__ + "static/media/rupees-icon-setting.7277f4a6.svg";